module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a86dc7e23b0b7d455cff4bdb4515ebf0.png";